export default "https://assets.egbcdn.net/assets/packs/_/images/app/android/android-ru-2-3ba619be90d445480f098fad5c11b8e0.png";